import {
  fixedLineSubscriptionMsg,
  mobileSubscriptionsMsg,
  subscriptionTypeMsg,
  t,
} from '../../../common/i18n/index.js';
import { SubscriptionType } from '../../../generated/api/subscriptionType.js';
import type { SearchFilterGroup } from '../../Table/SearchFilters.js';

export const ALL_CALLER_DISPLAY_SUBSCRIPTION_TYPES = [SubscriptionType.MOBILE, SubscriptionType.LANDLINE];

export const getCallerDisplaySubscriptionTypeFilterGroup = (subscriptionType = ''): SearchFilterGroup => {
  const enabled = new Set(subscriptionType.split('|'));
  return {
    label: () => t.QH8P(subscriptionTypeMsg),
    value: 'subscriptionType',
    items: [
      {
        label: () => t.OZCC(mobileSubscriptionsMsg),
        checked: enabled.has(SubscriptionType.MOBILE),
        value: SubscriptionType.MOBILE,
      },
      {
        label: () => t.N04E(fixedLineSubscriptionMsg),
        checked: enabled.has(SubscriptionType.LANDLINE),
        value: SubscriptionType.LANDLINE,
      },
    ],
  };
};
